<template>
    <b-row class="acum">
        <b-col cols="12"  lg="12" class="acum-fondo">
            <b-row>
                <b-col cols="11" class="mx-auto">
                    <p class="acum-titulo" v-html="content.titulo"></p>
                    <p class="acum-subtitulo mt-5" v-html="content.subtitulo"></p>    
                </b-col>
            </b-row>
            
        </b-col>
        <b-col cols="12" class="acum-fondo acum-fondo2"  lg="6" style="margin-bottom: -2rem">
            <img class="acum-sum" src="@/assets/images/user_internal/sum.png" alt="Sum icons img">
        </b-col>
        <b-col cols="12"  lg="6" style="margin-bottom: -2rem" class="acum-fondo acum-fondo3">
            <Sectionlist v-for="(item, index) in list" :key="index" :content="item"/>
        </b-col>
        <b-col cols="12"  lg="12" class="acum-poligono">
            <transition
                    enter-active-class="animated slideInUp"
                    leave-active-class="animated slideInDown">
                >
                <img v-if="show" class="acum-imagen" src="@/assets/images/user_internal/tlf_sum5.png" alt="Phone sum img">
            </transition>
            <!-- <div class="acum-poli"></div> -->
        </b-col>
        <b-col class="newimage">
            <img class="image-section-acum" src="@/assets/images/user_internal/tlf_sum5.png" alt="">
        </b-col>
    </b-row>
</template>
<script>
    import Sectionlist from '@/components/userInternal/section-list'

    export default {
        name: 'section-solutions',
        components: {
            Sectionlist
        },
        props: {
            content: Object
        },
        created: function () {
            var self = this;
            setTimeout(() => {
                self.show = true
            }, 10);
        },
        data: () => ({
            show: false,
            list: [
                {
                    title: 'Productos',
                    content: 'Canjea productos a <br>precios diferenciados <br>utilizando tus puntos.'
                },
                {
                    title: 'Promociones',
                    content: 'Activa tus cupones <br> y canjéalos en promociones <br> exclusivas.'
                },
                {
                    title: 'Descuentos',
                    content: 'Disfruta de descuentos <br> personalizados.'
                },
                {
                    title: 'Colecciones exclusivas',
                    content: 'Canjea productos premium <br> pensados especialmente <br> para ti, comprando en <br> establecimientos <br> seleccionados.'
                },
            ]
        }),
    }
</script>
<style scoped>

.newimage{
    display: none;
}

@media (max-width: 600px) {

    .acum{
        height: auto;
    }
    .acum-titulo{
        font-size: 30px;
    }

    .acum-subtitulo {
        font-size: 20px;
    }

    .acum-poligono {
        display: none;
    }

    .acum-fondo2 {
        display: none;
    }

    .newimage {
        margin-top: 30px;
        display: flex;
        height: 450px;
        z-index: 0;
        background-color: black;
        
    }

    .image-section-acum {
        width: max-content;
        margin-bottom: -33px;
    }
}

</style>